import React from 'react';

import City from '../../../types/City';
import Municipality from '../../../types/Municipality';

import Table from '../../common/ui/Table/Table';
import TableHead from '../../common/ui/Table/Head';
import CitiesTableRow from './TableRow';

interface Props {
  cities: City[];
  municipalities: Record<number, Municipality>;
  unauthorizedCallback: () => void;
  showError: (text: string) => void;

  sortData: { column: string; descending: boolean };
  setSortData: (data: { column: string; descending: boolean }) => void;
}

const CitiesTable = ({
  cities,
  municipalities,
  unauthorizedCallback,
  showError,
  sortData,
  setSortData,
}: Props) => {
  const citiesRows = cities.map((city: City) => (
    <CitiesTableRow
      key={city.id}
      city={city}
      municipalities={municipalities}
      unauthorizedCallback={unauthorizedCallback}
      showError={showError}
    />
  ));

  return (
    <Table>
      <TableHead
        columns={[
          { label: 'Название', width: '50%' },
          { label: 'Муниципалитет', width: '50%' },
        ]}
        sortingBy={sortData.column}
        descending={sortData.descending}
        setSortData={setSortData}
      />

      <tbody>{citiesRows}</tbody>
    </Table>
  );
};

export default CitiesTable;
